/** Входные пропсы от getFieldProps (FormErrors даёт helperText как string | string[]) */
interface FieldPropsIn {
  name?: string;
  error?: boolean;
  helperText?: string | string[];
  onChange?: (value: string | boolean) => void;
}

/** Выходные пропсы для UI (helperText только string, совместимо с BaseFieldProps) */
interface FieldPropsOut {
  name?: string;
  error?: boolean;
  helperText?: string;
  onChange?: (value: string | boolean) => void;
}

/**
 * Возвращает обёртку над getFieldProps, которая при каждом onChange вызывает onFieldChange
 * и передаёт значение в форму. Используется для отслеживания значений полей (например, для активности кнопки отправки).
 */
export function createGetFieldPropsWithTracking(
  getFieldProps: (name: string) => FieldPropsIn,
  onFieldChange: (name: string, value: string | boolean) => void
): (name: string) => FieldPropsOut {
  return (name: string): FieldPropsOut => {
    const props = getFieldProps(name);
    const originalOnChange = props.onChange;
    const helperText = Array.isArray(props.helperText)
      ? props.helperText[0]
      : props.helperText;
    return {
      ...props,
      helperText,
      onChange: (value: string | boolean) => {
        onFieldChange(name, value);
        originalOnChange?.(value);
      }
    };
  };
}
